import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import PageHeader from '../components/PageHeader';
import usePageSearchIndex from '../hooks/usePageSearchIndex';
import './ListOfServices.css';
import './Schemes.css'; // Import schemes CSS for table styles

// Export the Schemes Table as a reusable component
export const SchemesTable = () => {
  const { isMarathi } = useLanguage();

  return (
    <section className="schemes-section">
      <div className="schemes-table-container">
        <table className="schemes-table">
          <thead>
            <tr>
              <th>
                {isMarathi() ? 'अनुक्रमांक' : 'Serial No.'}
              </th>
              <th>
                {isMarathi() ? 'आर्थिक लाभाच्या योजना' : 'Financial Benefit Schemes'}
              </th>
              <th>
                {isMarathi() ? 'परिपत्रक' : 'Circular'}
              </th>
              <th>
                {isMarathi() ? 'फॉर्म' : 'Form'}
              </th>
              <th>
                {isMarathi() ? 'अंतिम तारीख' : 'Last Date'}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="scheme-serial">
                {isMarathi() ? '१' : '1'}
              </td>
              <td className="scheme-details">
                {isMarathi() ? 'सर्वसाधारण शैक्षणिक अर्थसहाय्य योजना' : 'General Educational Scholarship Scheme'}
              </td>
              <td className="scheme-more-info">
                <a href="https://mlwb.in/react-static-files/pdf/schemes/2025/20260131_General_Educational_Scholarship_Scheme_Circular.pdf" className="scheme-link" target="_blank" rel="noopener noreferrer" title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              </td>
              <td className="scheme-more-info">
                <a href="https://mlwb.in/react-static-files/pdf/schemes/2025/20260131_General_Educational_Scholarship_Scheme_Form.pdf" className="scheme-link" target="_blank" rel="noopener noreferrer" title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              </td>
              <td className="scheme-date">
                {isMarathi() ? '३१/०१/२०२६' : '31/01/2026'}
              </td>
            </tr>
            
            <tr>
              <td className="scheme-serial">
                {isMarathi() ? '२' : '2'}
              </td>
              <td className="scheme-details">
                {isMarathi() ? 'MPSC, UPSC आणि पीएच. डी अर्थसहाय्य योजना' : 'MPSC, UPSC And PH.D Scholarship Scheme'}
              </td>
              <td className="scheme-more-info">
                <a href="https://mlwb.in/react-static-files/pdf/schemes/2025/20260131_MPSC_UPSC_And_PH_D_Scholarship_Scheme_Circular.pdf" className="scheme-link" target="_blank" rel="noopener noreferrer" title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              </td>
              <td className="scheme-more-info">
                <a href="https://mlwb.in/react-static-files/pdf/schemes/2025/20260131_MPSC_UPSC_And_PH_D_Scholarship_Scheme_Form.pdf" className="scheme-link" target="_blank" rel="noopener noreferrer" title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              </td>
              <td className="scheme-date">
                {isMarathi() ? '३१/०१/२०२६' : '31/01/2026'}
              </td>
            </tr>
            
            <tr>
              <td className="scheme-serial">
                {isMarathi() ? '३' : '3'}
              </td>
              <td className="scheme-details">
                {isMarathi() ? 'परदेश शैक्षणिक अर्थसहाय्य योजना' : 'Foreign Higher Education Scholarship Scheme'}
              </td>
              <td className="scheme-more-info">
                <a href="https://mlwb.in/react-static-files/pdf/schemes/2025/20260131_Foreign_Higher_Education_Scholarship_Scheme_Circular.pdf" className="scheme-link" target="_blank" rel="noopener noreferrer" title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              </td>
              <td className="scheme-na">NA</td>
              <td className="scheme-date">
                {isMarathi() ? '३१/०१/२०२६' : '31/01/2026'}
              </td>
            </tr>
            
            <tr>
              <td className="scheme-serial">
                {isMarathi() ? '४' : '4'}
              </td>
              <td className="scheme-details">
                {isMarathi() ? 'क्रीडा अर्थसहाय्य योजना' : 'Sports Scholarship Scheme'}
              </td>
              <td className="scheme-more-info">
                <a href="https://mlwb.in/react-static-files/pdf/schemes/2025/20260131_Sports_Scholarship_Scheme_Circular.pdf" className="scheme-link" target="_blank" rel="noopener noreferrer" title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              </td>
              <td className="scheme-more-info">
                <a href="https://mlwb.in/react-static-files/pdf/schemes/2025/20260131_Sports_Scholarship_Scheme_Form.pdf" className="scheme-link" target="_blank" rel="noopener noreferrer" title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              </td>
              <td className="scheme-date">
                {isMarathi() ? '३१/०१/२०२६' : '31/01/2026'}
              </td>
            </tr>
            
            <tr>
              <td className="scheme-serial">
                {isMarathi() ? '५' : '5'}
              </td>
              <td className="scheme-details">
                {isMarathi() ? 'पाठ्यपुस्तक अर्थसहाय्य योजना' : 'Financial Assistance for Purchase of Text Books'}
              </td>
              <td className="scheme-more-info">
                <a href="https://mlwb.in/react-static-files/pdf/schemes/2025/20260131_Financial_Assistance_for_Purchase_of_Text_Books_Circular.pdf" className="scheme-link" target="_blank" rel="noopener noreferrer" title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              </td>
              <td className="scheme-na">NA</td>
              <td className="scheme-date">
                {isMarathi() ? '३१/०१/२०२६' : '31/01/2026'}
              </td>
            </tr>
            
            <tr>
              <td className="scheme-serial">
                {isMarathi() ? '६' : '6'}
              </td>
              <td className="scheme-details">
                {isMarathi() ? 'शिवणयंत्र अनुदान योजना' : 'Grant for the purchase of Sewing Machines scheme'}
              </td>
              <td className="scheme-more-info">
                <a href="https://mlwb.in/react-static-files/pdf/schemes/2025/20260131_Grant_for_Purchase_of_Sewing_Machines_Scheme_Circular.pdf" className="scheme-link" target="_blank" rel="noopener noreferrer" title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              </td>
              <td className="scheme-na">NA</td>
              <td className="scheme-date">
                {isMarathi() ? '३१/०१/२०२६' : '31/01/2026'}
              </td>
            </tr>
            
            <tr>
              <td className="scheme-serial">
                {isMarathi() ? '७' : '7'}
              </td>
              <td className="scheme-details">
                {isMarathi() ? 'शासकीय संगणक टंकलेखन बेसिक कोर्स प्रमाणपत्र परीक्षा GCC-TBC आर्थिक सहाय्य योजना' : 'Government Computer Typing Basic Course Certificate Examination GCC-TBC Financial Assistance Scheme'}
              </td>
              <td className="scheme-more-info">
                <a href="https://mlwb.in/react-static-files/pdf/schemes/2025/20260131_Government_Computer_Typing_Basic_Course_Certificate_Examination_GCC-TBC_Financial_Assistance_Scheme_Circular.pdf" className="scheme-link" target="_blank" rel="noopener noreferrer" title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              </td>
              <td className="scheme-na">NA</td>
              <td className="scheme-date">
                {isMarathi() ? '३१/०१/२०२६' : '31/01/2026'}
              </td>
            </tr>
            
            <tr>
              <td className="scheme-serial">
                {isMarathi() ? '८' : '8'}
              </td>
              <td className="scheme-details">
                {isMarathi() ? 'एम.एस.सी.आय.टी. सहाय्यता योजना' : 'MS-CIT Financial Assistance scheme'}
              </td>
              <td className="scheme-more-info">
                <a href="https://mlwb.in/react-static-files/pdf/schemes/2025/20260131_MS-CIT_Financial_Assistance_Scheme_Circular.pdf" className="scheme-link" target="_blank" rel="noopener noreferrer" title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              </td>
              <td className="scheme-more-info">
                <a href="https://mlwb.in/react-static-files/pdf/schemes/2025/20260131_MS-CIT_Financial_Assistance_Scheme_Form.pdf" className="scheme-link" target="_blank" rel="noopener noreferrer" title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              </td>
              <td className="scheme-date">
                {isMarathi() ? '३१/०१/२०२६' : '31/01/2026'}
              </td>
            </tr>
            
            <tr>
              <td className="scheme-serial">
                {isMarathi() ? '९' : '9'}
              </td>
              <td className="scheme-details">
                {isMarathi() ? 'गंभीर आजार वैद्यकीय उपचार सहायता योजना' : 'Financial assistance for critical illness treatment'}
              </td>
              <td className="scheme-more-info">
                <a href="https://mlwb.in/react-static-files/pdf/schemes/2025/20260131_Financial_Assistance_for_Critical_Illness_Treatment_Circular.pdf" className="scheme-link" target="_blank" rel="noopener noreferrer" title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              </td>
              <td className="scheme-more-info">
                <a href="https://mlwb.in/react-static-files/pdf/schemes/2025/20260131_Financial_Assistance_for_Critical_Illness_Treatment_Circular.pdf" className="scheme-link" target="_blank" rel="noopener noreferrer" title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              </td>
              <td className="scheme-date">
                {isMarathi() ? '३१/०१/२०२६' : '31/01/2026'}
              </td>
            </tr>
            
            <tr>
              <td className="scheme-serial">
                {isMarathi() ? '१०' : '10'}
              </td>
              <td className="scheme-details">
                {isMarathi() ? 'साहित्य प्रकाशन अनुदान योजना' : 'Literature Publication Grants Scheme'}
              </td>
              <td className="scheme-more-info">
                <a href="https://mlwb.in/react-static-files/pdf/schemes/2025/20260131_Literature_Publication_Grants_Scheme_Circular.pdf" className="scheme-link" target="_blank" rel="noopener noreferrer" title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              </td>
              <td className="scheme-na">NA</td>
              <td className="scheme-date">
                {isMarathi() ? '३१/०१/२०२६' : '31/01/2026'}
              </td>
            </tr>
            
            <tr>
              <td className="scheme-serial">
                {isMarathi() ? '११' : '11'}
              </td>
              <td className="scheme-details">
                {isMarathi() ? 'वाहन चालक प्रशिक्षण' : 'Driver Training'}
              </td>
              <td className="scheme-more-info">
                <a href="https://mlwb.in/react-static-files/pdf/schemes/2025/20260131_Driver_Training_Circular.pdf" className="scheme-link" target="_blank" rel="noopener noreferrer" title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              </td>
              <td className="scheme-na">NA</td>
              <td className="scheme-date">
                {isMarathi() ? '३१/०१/२०२६' : '31/01/2026'}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  );
};

const ListOfServices = () => {
  usePageSearchIndex({
    mr: ['सेवांची यादी', 'सेवा', 'योजना', 'आर्थिक लाभ'],
    en: ['list of services', 'services', 'schemes', 'financial benefit']
  });

  const pageHeaderData = {
    title: {
      marathi: 'सेवांची यादी',
      english: 'List of Services'
    },
    subtitle: {
      marathi: 'महाराष्ट्र कामगार कल्याण मंडळाच्या सेवांची यादी',
      english: 'List of Services provided by Maharashtra Labour Welfare Board'
    }
  };

  return (
    <div className="list-of-services-container">
      <PageHeader 
        title={pageHeaderData.title}
        subtitle={pageHeaderData.subtitle}
      />
      
      <div className="list-of-services-content" data-read-section="list-of-services-content">
        <SchemesTable />
      </div>
    </div>
  );
};

export default ListOfServices;

